import React, { useState, useEffect, useRef } from 'react';
import * as XLSX from 'xlsx';
import './CreateGroupPage.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrashAlt, faFileExcel, faSpinner } from '@fortawesome/free-solid-svg-icons';
import Galka from '../media/imagen/Galka.png'
import BigPlus from '../media/imagen/BigPlus.png'
import BigMinus from '../media/imagen/BigMinus.png'

const CreateGroupPage = () => { 
    const [groupName, setGroupName] = useState('');
    const [groupDescription, setGroupDescription] = useState('');
    const [members, setMembers] = useState([{ id: Date.now(), name: '', email: '' }]);
    const [importError, setImportError] = useState('');
    const [companyId, setCompanyId] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [saveStatus, setSaveStatus] = useState(null);
    const fileInputRef = useRef(null);

    // Загрузка companyId при монтировании компонента
    useEffect(() => {
        const fetchCompanyId = async () => {
            try {
                const token = localStorage.getItem('authToken');
                if (!token) {
                    console.error('Токен авторизации не найден');
                    return;
                }
                const url = new URL('http://185.250.149.189:8000/api/v1/Company');
                const response = await fetch(url, {
                method: 'GET',
                    headers: {
                        'Authorization': `Token ${token}`,
                        'Content-Type': 'application/json'
                     }
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                console.log (data);
                
                if (data.Company && data.Company.id) {
                    setCompanyId(data.Company.id);
                } else {
                    throw new Error('No companies found');
                }
            } catch (error) {
                console.error('Ошибка при загрузке companyId:', error);
                setSaveStatus({ type: 'error', message: 'Ошибка загрузки данных компании' });
            } finally {
                setIsLoading(false);
            }
        };

        fetchCompanyId();
    }, []);

    useEffect(() => {
        console.log ('Id компании:');
        console.log(companyId)
    }, [companyId]);

    // Обработчики изменений для полей группы
    const handleNameChange = (e) => setGroupName(e.target.value);
    const handleDescriptionChange = (e) => setGroupDescription(e.target.value);
    
    // Обработчики для участников
    const handleMemberNameChange = (id, value) => {
        setMembers(members.map(member => 
            member.id === id ? {...member, name: value} : member
        ));
    };

    const handleMemberEmailChange = (id, value) => {
        setMembers(members.map(member => 
            member.id === id ? {...member, email: value} : member
        ));
    };

    // Добавление нового участника
    const handleAddMember = () => {
        setMembers([...members, { id: Date.now(), name: '', email: '' }]);
    };

    // Удаление участника
    const handleRemoveMember = (id) => {
        if (members.length > 1) {
            setMembers(members.filter(member => member.id !== id));
        }
    };

    // Обработка сохранения
    const handleSave = async () => {
        if (!companyId) {
            setSaveStatus({ type: 'error', message: 'ID компании не загружен' });
            return;
        }

        if (!groupName.trim()) {
            setSaveStatus({ type: 'error', message: 'Введите название группы' });
            return;
        }

        // Проверка валидности email
        const invalidEmails = members.filter(member => {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return !emailRegex.test(member.email.trim());
        });

        if (invalidEmails.length > 0) {
            setSaveStatus({ 
                type: 'error', 
                message: `Некорректный email для: ${invalidEmails.map(m => m.name || 'участника').join(', ')}`
            });
            return;
        }

        const usersData = members.map((member, index) => ({
            user_id: index + 1,
            user_name: member.name,
            user_mail: member.email
        }));

        const postData = {
            company_id: companyId,
            name: groupName,
            description: groupDescription,
            users: usersData
        };

        try {
            setIsLoading(true);
            const token = localStorage.getItem('authToken');
            const response = await fetch('http://185.250.149.189:8000/api/v1/GroupUsers/', {
                method: 'POST',
                headers: {
                    'Authorization': `Token ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(postData)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Ошибка сохранения');
            }

            const result = await response.json();
            setSaveStatus({ type: 'success', message: 'Группа успешно сохранена!' });
            
            // Очистка формы после успешного сохранения
            setGroupName('');
            setGroupDescription('');
            setMembers([{ id: Date.now(), name: '', email: '' }]);
            
        } catch (error) {
            console.error('Ошибка сохранения:', error);
            setSaveStatus({ type: 'error', message: `Ошибка сохранения: ${error.message}` });
        } finally {
            setIsLoading(false);
        }
    };

    // Обработка импорта из Excel
    const handleImportClick = () => {
        fileInputRef.current.click();
    };

    const handleFileUpload = (e) => {
        setImportError('');
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (event) => {
            try {
                const data = new Uint8Array(event.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];
                
                const jsonData = XLSX.utils.sheet_to_json(worksheet);
                
                if (jsonData.length === 0) {
                    setImportError('Файл не содержит данных');
                    return;
                }
                
                const importedMembers = jsonData.map((row, index) => {
                    const nameKey = Object.keys(row).find(key => 
                        key.toLowerCase().includes('имя') || 
                        key.toLowerCase().includes('name') ||
                        key.toLowerCase().includes('фио')
                    );
                    
                    const emailKey = Object.keys(row).find(key => 
                        key.toLowerCase().includes('email') || 
                        key.toLowerCase().includes('почта') ||
                        key.toLowerCase().includes('e-mail')
                    );
                    
                    return {
                        id: Date.now() + index,
                        name: nameKey ? String(row[nameKey]) : '',
                        email: emailKey ? String(row[emailKey]) : ''
                    };
                }).filter(member => member.name || member.email);
                
                if (importedMembers.length === 0) {
                    setImportError('Не найдены подходящие данные для импорта');
                    return;
                }
                
                setMembers(importedMembers);
            } catch (error) {
                console.error('Ошибка импорта:', error);
                setImportError('Ошибка при чтении файла. Убедитесь, что файл в правильном формате.');
            }
        };
        
        reader.readAsArrayBuffer(file);
        e.target.value = null;
    };

    if (isLoading && !companyId) {
        return (
            <div className="loading-container">
                <FontAwesomeIcon icon={faSpinner} spin size="2x" />
                <p>Загрузка данных компании...</p>
            </div>
        );
    }

    return (
        <div className="GroupPattern"> 
            <div className="GroupPatternHead"> 
                <h1>Новая Группа</h1>
                <button 
                    className="SaveButton" 
                    onClick={handleSave}
                    disabled={isLoading}
                >
                    {isLoading ? (
                        <>
                            <FontAwesomeIcon icon={faSpinner} spin /> Сохранение...
                        </>
                    ) : (
                        <>
                            Сохранить
                            <img src={Galka} alt='Galka' />
                        </>
                    )}
                </button>
            </div>
            
            {saveStatus && (
                <div className={`save-status ${saveStatus.type}`}>
                    {saveStatus.message}
                </div>
            )}
            
            <div className="GroupPatternDescription"> 
                <div className="GroupName">
                    Название группы
                    <textarea 
                        className='input1' 
                        value={groupName}
                        onChange={handleNameChange}
                        placeholder="Введите название группы"
                        disabled={isLoading}
                    ></textarea>
                </div>
                <div className="GroupDes">
                    Описание <br/> группы
                    <textarea 
                        className='input2' 
                        value={groupDescription}
                        onChange={handleDescriptionChange}
                        placeholder="Опишите группу"
                        disabled={isLoading}
                    ></textarea>
                </div>
            </div>  

            <div className="group-header">
                <h2 className="group-members-title"> Добавьте участников в группу </h2>
                <div className="import-wrapper">
                    <button 
                        className="import-excel-btn" 
                        onClick={handleImportClick}
                        disabled={isLoading}
                    >
                    Импортировать из Excel
                    </button>
                    <input 
                        type="file" 
                        ref={fileInputRef}
                        onChange={handleFileUpload}
                        accept=".xlsx, .xls, .csv" 
                        style={{ display: 'none' }}
                        disabled={isLoading}
                    />
                    {importError && <div className="import-error">{importError}</div>}
                </div>
            </div>

<div className='GroupBoard'>
    {members.map((member, index) => (
        <div className='BoardItem' key={member.id}>
            <div className='ItemName'>
                <label>Фамилия, имя <span className='detail-label'>(сначала фамилия)</span></label>
                <input 
                    type='text' 
                    value={member.name}
                    onChange={(e) => handleMemberNameChange(member.id, e.target.value)}
                    placeholder="Введите фамилию и имя"
                    disabled={isLoading}
                /> 
            </div>
            <div className='ItemEmail'>
                <label>Email</label>
                <input 
                    type='email' 
                    value={member.email}
                    onChange={(e) => handleMemberEmailChange(member.id, e.target.value)}
                    placeholder="Введите email"
                    disabled={isLoading}
                /> 
            </div>
            
            <div className="member-actions" style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                {members.length > 1 && (
                    <button 
                        className="remove-member-btn"
                        onClick={() => handleRemoveMember(member.id)}
                        title="Удалить участника"
                        disabled={isLoading}
                        style={{background: 'none', border: 'none', cursor: 'pointer'}}
                    >
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </button>
                )}
                
                {index === members.length - 1 && (
                    <button 
                        className="add-member-btn"
                        onClick={handleAddMember}
                        title="Добавить участника"
                        disabled={isLoading}
                        style={{background: 'none', border: 'none', cursor: 'pointer'}}
                    >
                        <img src={BigPlus} alt='BigPlus' />
                    </button>
                )}
            </div>
        </div>
    ))}
</div>  
        </div>
    )
}

export default CreateGroupPage;